import uiStateReducer from "./uiStateReducer";

export default uiStateReducer;
